module.exports = __webpack_public_path__ + "img/img_hezuohuoban@2x.3150ca08.jpg";